import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { mtfindCpv } from "../api/mtfindCpv";
import { mtfindCpvId } from "../api/mtfindCpvId";
import { mtFindPerson } from "../api/mtFindPerson";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { testDownloadFile } from "../api/testDownloadFile";
import { validateComprobanteLaboral } from "../api/validateComprobanteLaboral";
import { jsPDF } from "jspdf";
import Modal from 'react-bootstrap/Modal';
import logo from '../assets/dpr_lab_logo.png';
import check1 from '../assets/Check1.png';
import dot from '../assets/reporte/dotList.png';
import "./print.css";
import "./style.css";

const N3_Autenticacion = () => {

    const componentRef = useRef(null);
    const isRunned = useRef(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [imagenFront, setImagenFront] = useState("");
    const [imagenFront2, setImagenFront2] = useState("");
    const [imagenFront3, setImagenFront3] = useState("");

    /*---Nombre reporte---*/

    const date = new Date();

    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');

    const [cpv, setCpv] = useState(params.get("i"));

    /*---------------------------*/

    const [vigenciaCpv, setVigenciaCpv] = useState("");
    const [numMiembrosFamilia, setNumMiembrosFamilia] = useState("");
    const [certificadoNacimiento, setCertificadoNacimiento] = useState("");
    const [certificadoMatrimonio, setCertificadoMatrimonio] = useState("");
    const [documentoMilitar, setDocumentoMilitar] = useState("");
    const [referenciasFamiliares, setReferenciasFamiliares] = useState("");
    const [equipo, setEquipo] = useState("");

    /*Nucleo Familiar Parentezco*/

    const [jefeIn, setJefeIn] = useState("");
    const [jefaIn, setJefaIn] = useState("");
    const [padreIn, setPadreIn] = useState("");
    const [madreIn, setMadreIn] = useState("");
    const [hermanoIn, setHermanoIn] = useState("");
    const [hijoIn, setHijoIn] = useState("");
    const [abueloIn, setAbueloIn] = useState("");
    const [nietosIn, setNietoIn] = useState("");
    const [padrastroIn, setPadrastroIn] = useState("");
    const [madrastraIn, setMadrastraIn] = useState("");
    const [hijastrosIn, setHijastrasIn] = useState("");
    const [parienteIn, setParienteIn] = useState("");
    const [amistadIn, setAmistadIn] = useState("");

    const [jefeDep, setJefeDep] = useState("");
    const [jefaDep, setJefaDep] = useState("");
    const [padreDep, setPadreDep] = useState("");
    const [madreDep, setMadreDep] = useState("");
    const [hermanoDep, setHermanoDep] = useState("");
    const [hijoDep, setHijoDep] = useState("");
    const [abueloDep, setAbueloDep] = useState("");
    const [nietosDep, setNietoDep] = useState("");
    const [padrastroDep, setPadrastroDep] = useState("");
    const [madrastraDep, setMadrastraDep] = useState("");
    const [hijastrosDep, setHijastrasDep] = useState("");
    const [parienteDep, setParienteDep] = useState("");
    const [amistadDep, setAmistadDep] = useState("");

    const [miembrosVisibles, setMiembrosVisibles] = useState([]);

    let jefeInCount = 0;
    let jefaInCount = 0;
    let padreInCount = 0;
    let madreInCount = 0;
    let hermanoInCount = 0;
    let hijoInCount = 0;
    let abueloInCount = 0;
    let nietosInCount = 0;
    let padrastroInCount = 0;
    let madrastraInCount = 0;
    let hijastrosInCount = 0;
    let parienteInCount = 0;
    let amistadInCount = 0;

    let jefeDepCount = 0;
    let jefaDepCount = 0;
    let padreDepCount = 0;
    let madreDepCount = 0;
    let hermanoDepCount = 0;
    let hijoDepCount = 0;
    let abueloDepCount = 0;
    let nietosDepCount = 0;
    let padrastroDepCount = 0;
    let madrastraDepCount = 0;
    let hijastrosDepCount = 0;
    let parienteDepCount = 0;
    let amistadDepCount = 0;

    const [imagenLogoDPRStr, setImagenLogoDPRStr] = useState("");
    const [carLogisticStr, setCarLogisticStr] = useState("");
    const [checkDeepBlueStr, setCheckDeepBlueStr] = useState("");

    const [experienciaRes, setExperienciaRes] = useState("");
    const [capacidadRes, setCapacidadRes] = useState("");
    const [competencia, setCompetencia] = useState("");
    const [conocimiento, setConocimiento] = useState("");
    const [alcohol, setAlcohol] = useState("");
    const [fatiga, setFatiga] = useState("");
    const [peatones, setPeatones] = useState("");
    const [interseccion, setInterseccion] = useState("");

    const [showTendencia, setShowTendencia] = useState(false);
    const [emiteTxt, setEmiteTxt] = useState("");
    const [listActividad, setListActividad] = useState([]);
    const [ingresoMensual, setIngresoMensual] = useState("");
    const [tendenciaBl, setTendenciaBl] = useState(false);
    const [listaAcademicolBl, setlistaAcademicolBl] = useState(false);
    const [nombreComprobante, setNombreComprobante] = useState("");

    const [cardSvgP, setCardSvgP] = useState("");
    const [logoDPR, setLogoDPR] = useState();
    const [check_deepBlue, setCheck_deepBlue] = useState("");
    const [cardSvgBlack, setCardSvgBlack] = useState("");
    const [qr, setQr] = useState("");

    const [strNivelMaximo, setStrNivelMaximo] = useState('');
    const [textoAp, setTextoAp] = useState('');

    const [numCedula, setnumCedula] = useState('');

    /*Nuevos states para Autenticacion Familiar*/
    const [numeroEstudios, setnumeroEstudios] = useState(3)

    /*Certificado de nacimiento*/
    const [verNacimiento, setVerNacimiento] = useState(false);
    const [actaNacimiento, setActaNacimiento] = useState('');
    const [fechaRegistroNacimiento, setFechaRegistroNacimiento] = useState('');
    const [libroNacimiento, setLibroNacimiento] = useState('');
    const [oficialiaNacimiento, setOficialiaNacimiento] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [entidadNacimiento, setEntidadNacimiento] = useState('');
    const [municipioNacimiento, setMunicipioNacimiento] = useState('');

    /*Certificado de matrimonio*/
    const [verMatrimonio, setVerMatrimonio] = useState(false);
    const [actaMatrimonio, setActaMatrimonio] = useState('');
    const [libroMatrimonio, setLibroMatrimonio] = useState('');
    const [oficialiaMatrimonio, setOficialiaMatrimonio] = useState('');
    const [paisMatrimonio, setPaisMatrimonio] = useState('');
    const [entidadMatrimonio, setEntidadMatrimonio] = useState('');
    const [municipioMatrimonio, setMunicipioMatrimonio] = useState('');
    const [curpConyugue, setCurpConyugue] = useState('');


    /*Documento militar*/
    const [verCartilla, setVerCartilla] = useState(false);
    const [numeroDocumentoMilitar, setNumeroDocumentoMilitar] = useState('');
    const [emisorDocumentoMilitar, setEmisorDocumentoMilitar] = useState('');
    const [documentoDocumentoMilitar, setDocumentoDocumentoMilitar] = useState('');

    /*Referencias*/
    const [fechaN3, setFechaN3] = useState('');
    const [fechaRecabado, setFechaRecabado] = useState('');

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            localStorage.clear();

            if (params.get("i") == null) {

                setLoading(false);
                setModalShow(false);
                setShow(true);
                setShowStatus(500);
                setShowMessage("Error al obtener el cpv")

            } else {

                setLoading(true);
                setTendenciaBl(false);

                const dataImgRepo = await generarImagenReporte();

                const cardSvgPStr =
                    "data:image/png;base64," + dataImgRepo.cardSvgP + "";

                const logoDPRStr =
                    "data:image/png;base64," + dataImgRepo.logoDPR + "";

                const check_deepBlueStr =
                    "data:image/png;base64," + dataImgRepo.check_deepBlue + "";

                const cardSvgBlackStr =
                    "data:image/png;base64," + dataImgRepo.cardSvgBlack + "";

                const qrStr =
                    "data:image/png;base64," + dataImgRepo.qr + "";


                setLogoDPR(logoDPRStr);
                setCardSvgP(cardSvgPStr);
                setCheck_deepBlue(check_deepBlueStr);
                setCardSvgBlack(cardSvgBlackStr);
                setQr(qrStr);

                const objCpv = {
                    cpv: params.get("i"),
                };

                const response = await mtfindCpvId(objCpv);

                if (response.status === 200) {

                    const objCons = {
                        id: response.id
                    }
                   
                    const responsePersonFind = await mtFindPerson(objCons);

                    if (response.listLaboral !== null) {
                        setListActividad(response.listLaboral);
                        setlistaAcademicolBl(false);
                    } else {
                        setlistaAcademicolBl(true);
                    }

                    setCompetencia(response.aniosExperiencia);
                    setIngresoMensual(response.ingresoMensual);

                    const objAWSImage = {
                        img: "N3_Nacimiento_" + params.get("i") + "_1.png",
                    };

                    const dataImgAWS = await testDownloadFile(objAWSImage);

                    const imagenStrFrontID =
                        "data:image/png;base64," + dataImgAWS.img + "";
                    setImagenFront(imagenStrFrontID);

                    //---------- Descarga imagen matrimonio  ------//

                    const objAWSImage2 = {
                        img: "N3_Matrimonio_" + params.get("i") + "_1.png",
                    };

                    const dataImgAWS2 = await testDownloadFile(objAWSImage2);

                    const imagenStrFrontID2 =
                        "data:image/png;base64," + dataImgAWS2.img + "";
                    setImagenFront2(imagenStrFrontID2);

                    //---------- Descarga imagen cartilla  ------//

                    const objAWSImage3 = {
                        img: "N3_Militar_" + params.get("i") + "_1.png",
                    };

                    const dataImgAWS3 = await testDownloadFile(objAWSImage3);

                    const imagenStrFrontID3 =
                        "data:image/png;base64," + dataImgAWS3.img + "";
                    setImagenFront3(imagenStrFrontID3);

                    // validacion de las tendencia de las images 

                    const objAWS = {
                        nombreUser: response.nombre,
                        paterno: response.paterno,
                        materno: response.materno,
                        nombreComprobante0: "N3_Nacimiento_" + params.get("i") + "_1.png",
                        nombreComprobante1: "N3_Matrimonio_" + params.get("i") + "_1.png",
                        nombreComprobante2: "N3_Militar_" + params.get("i") + "_1.png"
                    };

                    const responseComprobanteLaboral = await validateComprobanteLaboral(objAWS);

                    if (responseComprobanteLaboral.status !== 200) {
                        setTendenciaBl(true);
                    } else {
                        setTendenciaBl(false);
                    }

                    const imagenLogoDPR =
                        "data:image/png;base64," + response.logoDPR + "";
                    setImagenLogoDPRStr(imagenLogoDPR);

                    const imagenCarLogistic =
                        "data:image/png;base64," + response.carLogistic + "";
                    setCarLogisticStr(imagenCarLogistic);

                    const imagenCheckDeepBlue =
                        "data:image/png;base64," + response.checkDeepBlue + "";
                    setCheckDeepBlueStr(imagenCheckDeepBlue);

                    setNombreComprobante(response.comprobante);
                    setCpv(response.cpv);
                    setVigenciaCpv(response.vigenciaCpv);
                    setExperienciaRes(response.experienciaRes);
                    setCapacidadRes(response.capacidad);
                    setConocimiento(response.conocimiento);
                    setAlcohol(response.alcohol);
                    setFatiga(response.fatiga);
                    setPeatones(response.peatones);
                    setInterseccion(response.interseccion);
                    setEmiteTxt(response.emiteTxt);
                    setFechaN3(response.mensajeAntecedentes);

                    if (responsePersonFind.status === 200) {

                        setFechaRecabado(responsePersonFind.n3CompletoStr);

                        if (responsePersonFind.verNacimiento) {
                            setVerNacimiento(true);
                            setCertificadoNacimiento("Recabado");
                            setActaNacimiento(responsePersonFind.actaNacimiento);
                            setFechaRegistroNacimiento(responsePersonFind.fechaRegistroNacimiento);
                            setLibroNacimiento(responsePersonFind.libroNacimiento);
                            setOficialiaNacimiento(responsePersonFind.oficialiaNacimiento);
                            setPaisNacimiento(responsePersonFind.paisNacimiento);
                            setEntidadNacimiento(responsePersonFind.entidadNacimiento);
                            setMunicipioNacimiento(responsePersonFind.municipioNacimiento);
                        } else {
                            setCertificadoNacimiento("No Recabado");
                        }

                        if (responsePersonFind.verMatrimonio) {
                            setVerMatrimonio(true);
                            setCertificadoMatrimonio("Recabado");
                            setActaMatrimonio(responsePersonFind.actaMatrimonio);
                            setLibroMatrimonio(responsePersonFind.libroMatrimonio);
                            setOficialiaMatrimonio(responsePersonFind.oficialiaMatrimonio);
                            setPaisMatrimonio(responsePersonFind.paisMatrimonio);
                            setEntidadMatrimonio(responsePersonFind.entidadMatrimonio);
                            setMunicipioMatrimonio(responsePersonFind.municipioMatrimonio);
                            setCurpConyugue(responsePersonFind.curpConyugue);

                        } else {
                            setCertificadoMatrimonio("No Recabado");
                        }

                        if (responsePersonFind.verCartilla) {
                            setVerCartilla(true);
                            setDocumentoMilitar("Recabado");
                            setNumeroDocumentoMilitar(responsePersonFind.numeroCartilla);
                            setEmisorDocumentoMilitar(responsePersonFind.emisorCartilla);
                            setDocumentoDocumentoMilitar(responsePersonFind.fechaEmisionCartilla);
                        } else {
                            setDocumentoMilitar("No Recabado");
                        }

                    }
                    
                    console.log(paisNacimiento);
                    console.log(entidadNacimiento);
                    console.log(municipioNacimiento);

                    /** Miembros de familia */
                    const miembros = responsePersonFind.refNucleoN3.slice(0, 8); // Limitar a los primeros 8 miembros
                    setMiembrosVisibles(miembros);

                    setNumMiembrosFamilia(responsePersonFind.numerodePersonas);

                    for (let miembro of responsePersonFind.refNucleoN3) {
                        switch (miembro.parentezco) {
                            case "Jefe":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    jefeDepCount++;
                                    console.log(jefeDepCount);
                                } else {
                                    jefeInCount++;
                                    console.log(jefeInCount);
                                }
                                break;
                            case "Jefa":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    jefaDepCount++;
                                } else {
                                    jefaInCount++;
                                }
                                break;
                            case "Padre":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    padreDepCount++;
                                    console.log("numero padres: " + padreDepCount);
                                } else {
                                    padreInCount++;
                                    console.log(padreInCount);
                                }
                                break;
                            case "Madre":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    madreDepCount++;
                                    console.log("numero madres: " + madreDepCount);
                                } else {
                                    madreInCount++;
                                }
                                break;
                            case "Herman@":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    hermanoDepCount++;
                                } else {
                                    hermanoInCount++;
                                }
                                break;
                            case "Hij@":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    hijoDepCount++;
                                } else {
                                    hijoInCount++;
                                }
                                break;
                            case "Abuel@":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    abueloDepCount++;
                                } else {
                                    abueloInCount++;
                                }
                                break;
                            case "Niet@":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    nietosDepCount++;
                                } else {
                                    nietosInCount++;
                                }
                                break;
                            case "Padrastro":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    padrastroDepCount++;
                                } else {
                                    padrastroInCount++;
                                }
                                break;
                            case "Madrastra":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    madrastraDepCount++;
                                } else {
                                    madrastraInCount++;
                                }
                                break;
                            case "Hijastr@":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    hijastrosDepCount++;
                                } else {
                                    hijastrosInCount++;
                                }
                                break;
                            case "Pariente":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    parienteDepCount++;
                                } else {
                                    parienteInCount++;
                                }
                                break;
                            case "Amistad":
                                if (miembro.condicionEconomica === "Dependiente") {
                                    amistadDepCount++;
                                } else {
                                    amistadInCount++;
                                }
                                break;
                        }
                    }

                    setJefeDep(jefeDepCount.toString());
                    setJefeIn(jefeInCount.toString());
                    setJefaDep(jefaDepCount.toString());
                    setJefaIn(jefaInCount.toString());
                    setPadreDep(padreDepCount.toString());
                    setPadreIn(padreInCount.toString());
                    setMadreDep(madreDepCount.toString());
                    setMadreIn(madreInCount.toString());
                    setHermanoDep(hermanoDepCount.toString());
                    setHermanoIn(hermanoInCount.toString());
                    setHijoDep(hijoDepCount.toString());
                    setHijoIn(hijoInCount.toString());
                    setAbueloDep(abueloDepCount.toString());
                    setAbueloIn(abueloInCount.toString());
                    setNietoDep(nietosDepCount.toString());
                    setNietoIn(nietosInCount.toString());
                    setPadrastroDep(padrastroDepCount.toString());
                    setPadrastroIn(padrastroInCount.toString());
                    setMadrastraDep(madrastraDepCount.toString());
                    setMadrastraIn(madrastraInCount.toString());
                    setHijastrasDep(hijastrosDepCount.toString());
                    setHijastrasIn(hijastrosInCount.toString());
                    setParienteDep(parienteDepCount.toString());
                    setParienteIn(parienteInCount.toString());
                    setAmistadDep(amistadDepCount.toString());
                    setAmistadIn(amistadInCount.toString());


                    /**Referencias */



                    setnumCedula(responsePersonFind.numCedula);
                    setStrNivelMaximo(responsePersonFind.strNivelMaximo);

                    /***************************************************************************************** */

                    if (response.numImageTendencia === 1) {
                        setShowTendencia(true);
                    } else {
                        setShowTendencia(false);
                    }

                    handlePrint();

                } else {

                    setLoading(false);
                    setShow(true);
                    setShowStatus(response.status);
                    setShowMessage(response.message);

                }

                setLoading(false);

            }
        }

        createSession();

    }, [jefeDepCount, jefeInCount, jefaDepCount, jefaInCount, padreDepCount, padreInCount, madreDepCount, madreInCount, hermanoDepCount, hermanoInCount, hijoDepCount, hijoInCount,
        abueloDepCount, abueloInCount, nietosDepCount, nietosInCount, padrastroDepCount, padrastroInCount, madrastraDepCount, madrastraInCount, hijastrosDepCount, hijastrosInCount,
        parienteDepCount, parienteInCount, amistadDepCount, amistadInCount, municipioNacimiento, paisNacimiento, params]);


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async () => {
            const doc = new jsPDF();
            doc.html(componentRef.current, {
                html2canvas: {
                    removeContainer: true,
                    scale: 0.19
                },
                margin: 5,
                x: -1,
                async callback(doc) {
                    await doc.save('Laboral_' + cpv + '_' + formattedDate);
                },
            });
        },

    });

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>


            <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
                <div
                    className="animate__animated animate__fadeIn"
                    ref={componentRef}
                    style={{ display: "flex", width: "1070px", border: "none" }}
                >
                    <div className="relativeCSS">
                        <style type="text/css" media="print">
                            {
                                "@page {  size: A4;  }"
                            }
                        </style>
                        {/* hoja 1 */}
                        <br />
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <article className="newCard__style ">
                                        <div className="Bar__top p-2">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="col-3">
                                                        <img src={logo} alt="" className="w-100" />
                                                    </div>
                                                    <div className="col-9 ">
                                                        <div className="subtitle d-flex justify-content-start  h-100">
                                                            <div className="mt-3">
                                                                <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                                                <br />
                                                                <h5 className="Bar__top--sizing p-0">Autenticación Familiar</h5>
                                                            </div>
                                                            <section className="mt-2">
                                                                <div className="Bar__button rounded-pill">
                                                                    <span className="p-1"><strong>IDe</strong></span>
                                                                </div>
                                                            </section>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="conteiner-fluid info-Bar">
                                            <div className="row p-3 ">
                                                <div className="col-8">
                                                    <ul className="pNone text-start p-3">
                                                        <li className="d-flex justify-content-start align-items-center mb-2">
                                                            <img src={check1} alt="" className="imgCheck--size" />
                                                            <span className="f20 pb-1">Información Requerida</span>
                                                        </li>
                                                        <li className="d-flex justify-content-start align-items-center mb-2">
                                                            <img src={check1} alt="" className="imgCheck--size" />
                                                            <span className="f20 pb-1">Documentación Probatoria</span>
                                                        </li>
                                                        <li className="d-flex justify-content-start align-items-center mb-2">
                                                            <img src={check1} alt="" className="imgCheck--size" />
                                                            <span className="f20 pb-1">Antecedentes Penales</span>
                                                        </li>
                                                        <br />
                                                        <br />
                                                        <div className=" d-flex Info__aling align-items-end">
                                                            <div className="expires">
                                                                <span className="text-lg">Vence &nbsp;: <strong>{vigenciaCpv}</strong> </span>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                                <div className="col-4">
                                                    <section className=" d-flex flex-column w-100">
                                                        <img className="  " src={qr} alt="" />
                                                        <span className="cpv__text  text-center mt-1">CPV&nbsp;: <strong>{cpv}</strong> </span>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                    <div className="text-one">
                                        <div className="textInfo f12">
                                            ATENCIÓN &nbsp;:&nbsp; Este certificado es válido únicamente si la fecha en el recuadro superior
                                            izquierdo de este Reporte se encuentra vigente. Para comprobar su autenticidad
                                            escanee el código QR y/o ingrese el código CPV en www.midpr.net.
                                        </div>
                                    </div>
                                    <div className="textNotifique pt-0">
                                        *Notifique si este Reporte ha sido alterado al +52 5571605526 y/o en
                                        www.midpr.net
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="subTitleCardTwo f12 subTitleCardTwo__sizing">
                                        Este &nbsp; Reporte da constancia de la recopilación y corroboración de información aportada por el Aplicante a través de medios digitales, de manera completa y concluyente, obteniendo la información presentada a continuación:
                                    </div>
                                    <br />

                                    <article className="card digital-data">

                                        <div className="titleCard">Resultado &nbsp; obtenido</div>
                                        <table>
                                            <tbody>
                                                <tr className="txtLi"> &nbsp;<img src={dot} alt="" /> &nbsp;<span>Número de miembros de la familia: <strong>{numMiembrosFamilia}</strong></span></tr>
                                                <tr className="txtLi"> &nbsp;<img src={dot} alt="" /> &nbsp;<span>Certificado de nacimiento: <strong>{certificadoNacimiento}</strong></span></tr>
                                                <tr className="txtLi"> &nbsp;<img src={dot} alt="" /> &nbsp;<span>Certificado de matrimonio: <strong>{certificadoMatrimonio}</strong></span> </tr>
                                                <tr className="txtLi"> &nbsp;<img src={dot} alt="" /> &nbsp;<span>Documento militar: <strong>{documentoMilitar}</strong></span></tr>
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center  align-items-center">
                                            <button type="button" className="inter rounded-pill"><b>Alertas Registradas 0</b></button>
                                        </div>


                                    </article>
                                    <div className="textNotifique pt-0">
                                        *La interpretación de este Resultado Obtenido es
                                        responsabilidad exclusiva del lector.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">

                                    <div className="card">

                                        <div className="titleCard pt-1">
                                            NÚCLEO &nbsp; FAMILIAR
                                        </div>

                                        <div className="f12 lel">
                                            <table className=" table__Aut">
                                                <thead className="table__Aut__Head ">
                                                    <tr className="table__Aut__Txt table__Aut__txt">
                                                        <td className="p-2">Parentesco</td>
                                                        <td>Dependientes</td>
                                                        <td>Independientes</td>
                                                        <td className="text-center">Parentesco</td>
                                                        <td>Dependientes</td>
                                                        <td>Independientes</td>
                                                    </tr>

                                                </thead>
                                                <tbody className="table__Aut__Txt__Body table__bars">
                                                    <tr>
                                                        <td>Jefe</td>
                                                        <td className="txt-center">{jefaDep}</td>
                                                        <td className="txt-center">{jefeIn}</td>
                                                        <td>Niet@</td>
                                                        <td className="txt-center">{nietosDep}</td>
                                                        <td className="txt-center">{nietosIn}</td>
                                                    </tr>
                                                    <tr >
                                                        <td>Jefa</td>
                                                        <td className="txt-center">{jefaDep}</td>
                                                        <td className="txt-center">{jefaIn}</td>
                                                        <td>Padrastro</td>
                                                        <td className="txt-center">{padrastroDep}</td>
                                                        <td className="txt-center">{padrastroIn}</td>
                                                    </tr>
                                                    <tr >
                                                        <td>Padre</td>
                                                        <td className="txt-center">{padreDep}</td>
                                                        <td className="txt-center">{padreIn}</td>
                                                        <td>Madrastra</td>
                                                        <td className="txt-center">{madrastraDep}</td>
                                                        <td className="txt-center">{madrastraIn}</td>
                                                    </tr>
                                                    <tr >
                                                        <td>Madre</td>
                                                        <td className="txt-center">{madreDep}</td>
                                                        <td className="txt-center">{madreIn}</td>
                                                        <td>Hijastr@</td>
                                                        <td className="txt-center">{hijastrosDep}</td>
                                                        <td className="txt-center">{hijastrosIn}</td>
                                                    </tr>

                                                    <tr >
                                                        <td>Herman@</td>
                                                        <td className="txt-center">{hermanoDep}</td>
                                                        <td className="txt-center">{hermanoIn}</td>
                                                        <td>Pariente</td>
                                                        <td className="txt-center">{parienteDep}</td>
                                                        <td className="txt-center">{parienteIn}</td>
                                                    </tr>

                                                    <tr>
                                                        <td>Hij@</td>
                                                        <td className="txt-center">{hijoDep}</td>
                                                        <td className="txt-center">{hijoIn}</td>
                                                        <td>Amistad</td>
                                                        <td className="txt-center">{amistadDep}</td>
                                                        <td className="txt-center">{amistadIn}</td>
                                                    </tr>

                                                    <tr>
                                                        <td>Abuel@</td>
                                                        <td className="txt-center">{abueloDep}</td>
                                                        <td className="txt-center">{abueloIn}</td>
                                                        <td> </td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>


                                                </tbody>                                            </table>
                                        </div>
                                    </div>
                                    <br />

                                    <div className="buttonCenter">

                                        {!tendenciaBl ? (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn green trend rounded-pill">
                                                        TENDENCIA &nbsp; A CONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn yellow trend rounded-pill">
                                                        TENDENCIA &nbsp; A INCONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div className="f12--sizing text-center pt-1">
                                        *Consulte definiciones de estas métricas en www.midpr.net.
                                    </div>

                                </div>

                                <div className="col-6">

                                    <div className="card evaluated-areas tipo-d borderCard pt-1">
                                        <div className="titleCard">
                                            DOCUMENTACIÓN  &nbsp; PROBATORIA
                                        </div>
                                        <div className=" Document__txtBody__sizing Document__txtBody Word__Spacing">

                                            {verNacimiento ? (
                                                <>
                                                    <div className="mb-2"><b>Certificado de nacimiento</b></div>
                                                    <article className="f14">
                                                        <b>Número</b>&nbsp;:&nbsp;{oficialiaNacimiento + " / " + fechaRegistroNacimiento + " / " + libroNacimiento + " / " + actaNacimiento}
                                                        <br />
                                                        <b>Emisor</b>&nbsp;:&nbsp;{"Registro Civil " + entidadNacimiento}
                                                        <br />
                                                        <b>Documento</b>&nbsp;:&nbsp;{"Acta de Nacimiento"}
                                                        <br />
                                                        <b>Lugar</b>&nbsp;:&nbsp;{paisNacimiento + ", " + entidadNacimiento + ", " + municipioNacimiento}
                                                        <br />
                                                        <b>Estatus</b>&nbsp;:&nbsp;{certificadoNacimiento + " / " + fechaRecabado}
                                                    </article>
                                                </>
                                            ) : (
                                                <> </>
                                            )}

                                            {verMatrimonio ? (
                                                <>
                                                    <div className="mt-2 mb-2"><b>Certificado de matrimonio</b></div>
                                                    <article className="f14 ">
                                                        <b>Número</b>&nbsp;:&nbsp;{oficialiaMatrimonio + " / " + libroMatrimonio + " / " + actaMatrimonio}
                                                        <br />
                                                        <b>Emisor</b>&nbsp;:&nbsp;{"Registro Civil " + entidadMatrimonio}
                                                        <br />
                                                        <b>Documento</b>&nbsp;:&nbsp;{"Acta de Matrimonio"}
                                                        <br />
                                                        <b>CURP Cónyugue</b>&nbsp;:&nbsp;{curpConyugue}
                                                        <br />
                                                        <b>Lugar</b>&nbsp;:&nbsp;{paisMatrimonio + ", " + entidadMatrimonio + ", " + municipioMatrimonio}
                                                        <br />
                                                        <b>Estatus</b>&nbsp;:&nbsp;{certificadoMatrimonio + " / " + fechaRecabado}
                                                    </article>
                                                </>
                                            ) : (
                                                <> </>
                                            )}

                                            {verCartilla ? (
                                                <>
                                                    <div className="mt-2 mb-2"><b>Documento militar</b></div>
                                                    <article className="f14">
                                                        <b>Número</b>&nbsp;: &nbsp;{numeroDocumentoMilitar}
                                                        <br />
                                                        <b>Emisor</b>&nbsp;:&nbsp; {"Secretaria de la Defensa Nacional"}
                                                        <br />
                                                        <b>Documento</b>&nbsp;:&nbsp; {"Cartilla Militar"}
                                                        <br />
                                                        <b>Pais</b>&nbsp;:&nbsp; {emisorDocumentoMilitar}
                                                        <br />
                                                        <b>Fecha de emisión</b>&nbsp;:&nbsp; {documentoDocumentoMilitar}
                                                    </article>
                                                </>
                                            ) : (
                                                <> </>
                                            )}
                                        </div>

                                    </div>

                                    <div className="textNotifique pt-1">
                                        *Consulte al reverso de este Reporte las imágenes recabadas
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <br />
                                    <div className="subTitleCardTwo f12">
                                        Este proceso de certificacíon fue realizado de manera automatica a través de un
                                        dispositivo digital propiedad del Aplicante. Durante el proceso, se registraron
                                        una serie de datos de carácter personal que fueron analizados, validados y/o
                                        verificados que permitieron, posterior al análisis de la información, la obtención
                                        del dictamen presentado con respecto a la consistrencia o inconsistencia de estos
                                        de manera integral.
                                    </div>
                                </div>

                                <div className="col-6">
                                    <br />
                                    <div className="card evaluated-areas tipo-d borderCard pt-1">
                                        <div className="titleCard">
                                            ANTECEDENTES   &nbsp; PENALES
                                        </div>

                                        <div className="subTitleCardTwo f12">
                                            De la consulta con fecha del <strong>  {fechaN3}</strong> a listados <strong>criminales y litigios,</strong>  se verificó la existencia de registros, obteniendo:
                                        </div>
                                        <span className="text-center pt-1 pb-0"><b><strong>  Ninguno</strong> </b> </span>

                                    </div>
                                </div>

                            </div>
                            <div className="note-gray note-emit">
                                <p>
                                    {emiteTxt}
                                </p>
                            </div>
                            <div className="textNotifique pt-1">
                                *Consulte al reverso nuestra Política de Privacidad y/o en www.midpr.net
                            </div>


                            <div className="card legal-advise borderCard">
                                <div className="titleCard  TitleAviso pb-1">AVISO &nbsp; LEGAL</div>
                                <div className="subTitleCardTwo f12 ">
                                    <p >
                                        La Calificación realizada de manera
                                        remota por el Aplicante, a la que hace
                                        referencia este Reporte, fue realizada
                                        a solicitud directa del Destinatario.
                                        Antes y durante la Calificación &nbsp;, fue
                                        autenticada la identidad del Aplicante{" "}
                                        y se registraron una serie de datos e información de
                                        carácter personal con su autorización expresa &nbsp;, lo cual
                                        permitió emitir una Evaluación Remota Confiable (&nbsp; ERC &nbsp;).
                                        El Destinatario acepta que todos los
                                        datos contenidos en el presente Reporte{" "}
                                        son confidenciales y de interés exclusivo y privado, que
                                        es compartida únicamente con el propósito que ha sido
                                        previamente informado por el{" "}
                                        Destinatario y que ha autorizado por el{" "}
                                        Aplicante previo a la aplicación de la{" "}
                                        Calificación &nbsp;. El{" "}
                                        Aplicante y/o el{" "}
                                        Destinatario de este Reporte aceptan de
                                        conformidad la responsabilidad sobre cualquier uso
                                        indebido o ilegal de este documento y su contenido, así
                                        como todos los términos y condiciones descritos al
                                        reverso.{" "}

                                        Una vez entregado este Reporte al Destinatario, el
                                        Fabricante se deslinda de toda responsabilidad sobre
                                        su interpretación, divulgación y uso

                                        .
                                    </p>
                                </div>
                            </div>
                            <div className="textNotifique f12">
                                Business &nbsp; Prey SA de CV hace referencia que con número de
                                registro DGSP&nbsp;/369-19/3919, está autorizada por la SSPC&nbsp;/DGSP
                                para la aplicación de Pruebas y Evaluación &nbsp; de Control de
                                Confianza de conformidad con los Lineamientos y Criterios
                                Técnicos &nbsp; publicados en el Diario Oficial de la Federación
                                (DOF) el 28 de abril de 2020.
                            </div>
                            <div style={{ paddingTop: "", background: "#FFF" }}>
                            </div>
                        </div>
                        <br />
                        <br />

                        {/* hoja 2 */}

                        <br />
                        <br />
                        <br />

                        <div className="div-vertical mt-15">
                            <div className="div-horizontal" id="div1">
                                <div className="card evaluated-areas tipo-d borderCard">
                                    <div className="titleCard">IMÁGENES &nbsp; RECABADAS</div>
                                    <div className="w-100 p-3 Img__Grid">
                                        <img src={imagenFront} alt="" className="Birth--sizingN3" />
                                        <img src={imagenFront2} alt="" className="Birth--sizingN3" />
                                        <img src={imagenFront3} alt="" className="Birth--sizingN3" />
                                    </div>

                                </div>
                                <br />
                                <div className="card evaluated-areas tipo-d borderCard">

                                    <div className="titleCard">HABITANTES DEL HOGAR</div>

                                    <div className="Reference d-flex w-100 Reference__txt justify-content-around">


                                        {miembrosVisibles.map((miembro, index) => (
                                            <div key={index}>
                                                <p><b>PII&nbsp;:&nbsp;</b> {miembro.curp}</p>
                                                <p><b>Teléfono&nbsp;:&nbsp;</b> {miembro.telefono}</p>
                                                <p><b>Email&nbsp;:&nbsp;</b> {miembro.correo}</p>
                                                <p><b>Tipo de relación</b>&nbsp;:&nbsp; {miembro.parentezco}</p>
                                                <p> <b>Condición Económica&nbsp;:&nbsp;</b> {miembro.condicionEconomica}</p>

                                            </div>
                                        ))}


                                    </div>

                                </div>
                                <br />

                                <div>
                                    <div className="card evaluated-areas tipo-d borderCard">
                                        <div className="titleCard">TEMAS DE INTERÉS</div>
                                        <div className="subTitleCardTwo f12">

                                            {verNacimiento ? (
                                                <>
                                                    <strong>Certificado de nacimiento: </strong>
                                                    Oficialia (recabado), Libro (recabado),
                                                    Acta (recabado), Folio (recabado), Pais (recabada), estado (recabada),
                                                    municipio (recabada), fecha de emisión (recabada), imagen (recabada).

                                                </>
                                            ) : (
                                                <> </>
                                            )}
                                            <br />
                                            {verMatrimonio ? (
                                                <>
                                                    <strong>Certificado de matrimonio: </strong>
                                                    Oficialia (recabado), Libro (recabado),
                                                    Acta (recabado), Folio (recabado), Pais (recabada), estado (recabada),
                                                    municipio (recabada), conyugue (recabada), imagen (recabada).

                                                </>
                                            ) : (
                                                <> </>
                                            )}
                                            <br />
                                            {verCartilla ? (
                                                <>
                                                    <strong>Cartilla militar: </strong>
                                                    Número de matricula (recabado), Pais (recabada), fecha de emisión (recabada), imagen (recabada).
                                                </>
                                            ) : (
                                                <> </>
                                            )}

                                        </div>
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Privacidad de Datos Personales &nbsp;</b>
                                        <br />
                                        Para efectos del
                                        cumplimiento del artículo 9 de la Ley Federal de
                                        Protección de Datos Personales en Posesión de los
                                        Particulares (LFPDPPP &nbsp;), el Aplicante de la ERC manifiesta
                                        expresamente que otorgó su consentimiento para el
                                        tratamiento de sus datos personales sensibles, durante los
                                        procedimientos de recopilación y procesamiento, aceptando
                                        los términos y condiciones para tales efectos.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de las &nbsp; Marcas &nbsp;</b>
                                        <br />
                                        DPR &nbsp;y las marcas asociadas son marcas
                                        registradas, protegida por los artículos 88 y 142 de la
                                        Ley de Propiedad Industrial (LPI &nbsp;), así como el convenio de
                                        París para efectos internacionales. El consumo o
                                        adquisición de cualquiera de los servicios vinculados a
                                        DPR &nbsp; y/o proporcionados por el Fabricante, no confieren al
                                        Aplicante y/o al Destinatario el derecho de uso de las
                                        marcas de DPR en ningún contexto y/o formato, ya que al
                                        hacerlo podría resultar en actividad fraudulenta y ser
                                        clasificado como un delito. La marca, propiedad
                                        intelectual o cualquier otro tipo de secreto industrial
                                        contenido en este Reporte, no autoriza el uso, explotación
                                        comercial, venta, reproducción o distribución de dicha
                                        información.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de Información por Terceros &nbsp;</b>
                                        <br />
                                        Al realizar la IDe, el Aplicante autoriza la entrega de los datos obtenidos al
                                        Destinatario para el uso particular que ambos hayan acordado.
                                    </div>


                                    <div className="note-gray ">
                                        <p>
                                            <strong>Business &nbsp; Prey SA de CV</strong> con domicilio en
                                            Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                                            DPR. Para mayor información llame al +52 5571605526 o
                                            visite el sitio <strong>www.midpr.net</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default N3_Autenticacion